export const calendarCategoriesColorOptions: string[] = [
  '#ffffff',
  '#e5b0b3',
  '#efd2b2',
  '#eed9b6',
  '#f2e5b5',
  '#f9f2ba',
  '#e7dcc9',
  '#c9dfb7',
  '#cfe8c7',
  '#e1e9d2',
  '#c2e7e5',
  '#b4dbe4',
  '#b8e0e5',
  '#c2dde6',
  '#c9e7f2',
  '#d7d3e9',
  '#e0cfe9',
  '#eccde7',
  '#e1e4e8',
  '#D4F4FD', // Add more or adjust as desired
];


export const eventReminderOptions = [
  'Don\'t remind me',
  'At time of event',
  '5 minutes before',
  '10 minutes before',
  '15 minutes before',
  '1 hour before',
  '2 hours before',
  '12 hours before',
  '1 day before',
  '1 week before',
  // 'Add email reminder',
];



export const eventDayOptions = [
  { label: '1 day', value: 1 },
  { label: '2 days', value: 2 },
  { label: '3 days', value: 3 },
  { label: '4 days', value: 4 },
  { label: '5 days', value: 5 },
  { label: 'custom', value: 7 },
];
